<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M43.5 24.25a2 2 0 00-1-1.73l-3.9-2.27L42.51 18a2 2 0 000-3.46L25 4.35a2 2 0 00-2 0L5.49 14.52a2 2 0 000 3.46l3.91 2.27-3.91 2.27a2 2 0 000 3.46L9 28l-3.51 2a2 2 0 000 3.46L23 43.65a2 2 0 002 0l17.51-10.17a2 2 0 000-3.46L39 28l3.48-2a2 2 0 001.02-1.75zM24 7.23l15.51 9L24 25.27l-15.51-9zm15.51 24.52L24 40.77l-15.51-9 3.46-2L23 36.15a2 2 0 002 0l11-6.42zM24 33.27l-15.51-9L12.38 22 23 28.15a2 2 0 002 0L35.62 22l3.89 2.26z"/></svg>